import React, { useState, useContext, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";

import Swal from "sweetalert2";

import LogoMain from "../../../assets/images/altruist_logo.png";
import { AppContext } from "../../../context/AppContext";
import { ForgetPasswordSendLink, LoginUser } from "../../../api/Api";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../../utils/common-utils";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const { setContextStates } = useContext(AppContext);
  const [inputData, setInputData] = useState({
    email: "",
  });
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(false);

  const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email } = inputData;
    if (!email || !emailRegex.test(email)) {
      setError(true);
    } else {
      setLoader(true);
      let payload = {
        email: email,
      };
      const response = await ForgetPasswordSendLink(payload);
      console.log("response", response);
      setLoader(false);
      if (response?.data?.statusDescription?.status == 200) {
        Swal.fire({
          text: response?.data?.statusDescription?.description,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          text: response?.data?.statusDescription?.description,
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    }
  };

  return (
    <div className="bg_image align-items-left min-vh-100">
      <div className="container my-auto">
        <div className="login-box">
          <div className="login-logo">
            <img src={LogoMain} alt="logo" width="123px" />
          </div>
          <div className="login-box-body">
            <p className="login-box-msg mb-3">Enter your Registered email id</p>
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group has-feedback">
                <input
                  type="email"
                  className={`form-control ${
                    error &&
                    (!inputData.email || !emailRegex.test(inputData.email))
                      ? "is-invalid"
                      : ""
                  }`}
                  placeholder="Email Id"
                  value={inputData.email}
                  onChange={(e) =>
                    setInputData({ ...inputData, email: e.target.value })
                  }
                  maxLength="50"
                  required
                />
                {error &&
                  (!inputData.email || !emailRegex.test(inputData.email)) && (
                    <div className="invalid-feedback d-block error">
                      {!inputData.email
                        ? "Please enter an email id"
                        : inputData.email && !emailRegex.test(inputData.email)
                        ? "Please enter a valid email id"
                        : ""}
                    </div>
                  )}
              </div>

              <div className="d-flex justify-content-between">
               
                <button
                  type="button"
                  className="btn btn-dark btn-custom-width"
                  onClick={() => navigate("/")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-custom-bg"
                  disabled={loader}
                >
                  Send Link {loader && <i className="fa fa-spinner fa-spin"></i>}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
